module.exports = __webpack_public_path__ + "img/hc-floorplan-drawings.f4b9ab88.png";